import { CountrySliceState } from 'src/core/models'

const countryState: CountrySliceState = {
  countryList: {
    loading: false,
    data: []
  }
}

export { countryState as initialState }
